module.exports = __webpack_public_path__ + "static/ja-240c563621f052f6e666af7b36f78a7e.png";